import styled from "styled-components"

export const Video = styled.video`
	width: 100%;
	height: 100%;
	object-position: 50% 50%;

	display: block;
`
